import {
  IPlayer, ObjectMap, PsmVideoPlayer,
} from '../../common/interfaces'
import { logger } from '../../utils'

// TODO: add unit test(s)
class DiscoveryPlayer implements IPlayer {
  player: PsmVideoPlayer
  asyncMetadata: ObjectMap

  constructor(videoPlayer: PsmVideoPlayer) {
    this.player = videoPlayer
  }

  sendPsmEvent(eventName: string): void {
    // TODO: send event to queue from discovery player
    logger('discovery sendPsmEvent ----', eventName)
  }

  sendMetadataMap(data: ObjectMap): void {
    data
  }

  // Listen to ALL of Discovery listeners
  activateListeners(eventBuilder, psmActiveConfigEvents?: string[]): void {
    // this.player?.events?.unlistenAll()
    this.player?.events?.listen((type: string, results: any): void => {
      if (psmActiveConfigEvents?.includes(type)) {
        logger(`==> ${type} is the key in EventMap <==`)
        logger(`==> ${results} is the result from event <==`)
      }
    })
  }
}

export default DiscoveryPlayer
